import ConsumptionREST from './customREST/consumption';
import ConsumptionActions from './actions/consumption';

//If you add a custom repository in this array it will be dynamically added to the repository custom options when get: is called.
const REST = {
  consumption: ConsumptionREST,
};
const ACTIONS = {
  consumption: ConsumptionActions,
};

class Repository {
  //Generate a repository for the resource (The /controller route with all the main and custom routes)
  constructor(resource, organisationCode, id, key, type) {
    this.publicUrl =
      process.env.VUE_APP_API_URL + `shared/${organisationCode}/${resource}`;
    this.resource = resource;
    this.customConfig = {
      headers: {
        'WC-Organisation-Code': organisationCode,
        'WC-Shared-Id': id,
        'WC-Shared-Key': key,
        'WC-Shared-Key-Type': type,
      },
    };

    let customREST = REST[resource];
    if (customREST != undefined) {
      this.customREST = new customREST(this.publicUrl, this.customConfig);
    }

    let action = ACTIONS[resource];
    if (action != undefined) {
      this.actions = new action(this.publicUrl, this.customConfig);
    }
  }
}

//When you get any repository with his name in parameter it will generate a repository with all the default and custom routes.
export default {
  get: (name, organisationCode, id, key, type) => {
    return new Repository(name, organisationCode, id, key, type);
  },
};
